<app-material>
    <ng-container header>
        <div class="header">
            <h2>{{ 'admin.tools.title' | translate }}</h2>
            <div class="mutators">
                <app-button *ngIf="canManageTools()"
                            (clicked)="addToolFromModal()">{{ 'admin.tools.form.title' | translate }}
                </app-button>

                <app-button (clicked)="onDownloadToolsReport()">
                    {{ 'reportDownloadForm.downloadButton' | translate }}
                </app-button>
                <app-dropdown-button
                    *ngIf="selectedToolCount > 0"
                    [model]="batchActions"
                    [label]="'admin.tools.buttons.actions' | translate: {selectedTools: selectedToolCount}"
                    type="secondary">
                </app-dropdown-button>
                <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
            </div>
        </div>
    </ng-container>
    <ng-container body>
        <app-admin-tools-table
            [isReadOnly]="!canSelectTools()"
            [canManageTools]="canManageTools()"
            [toolsGrouped]="toolsGrouped"
            [selectedTools]="selectedTools"
            [isLoading]="isLoadingTools"
            [tableConfig]="tableConfig"
            [showFilters]="filtersToggled"
            [isFiltersExpanded]="filtersToggled"
            [selectableTools]="selectableTools"
            [hasTitle]="false"
            [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
            [filterBySecLinesId]=filterBySecLinesId
            [isSelectAllChecked]="allToolsAreSelected"
            [hasSelectAll]="canSelectTools()"
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilterChange($event)"
            (filterGroupChange)="onFilterGroupChange($event)"
            (pageChange)="onPageChange($event)"
            (duplicateRow)="onDuplicateRow($event)"
            (addToolIntoSet)="onAddToolInSet($event)"
            (deleteSet)="onDeleteSet($event)"
            (filterBySecLines)="onFilterBySecLines($event)"
            (filterByDocumentationValidity)="onFilterByDocumentationValidity($event)"
            (openDetais)="openToolDetails($event)"
            (openDetailsNewPage)="openToolDetailsNewPage($event)"
            (onToolClicked)="onToolClicked($event)"
            (selectAll)="selectAll()"
            (unselectAll)="unselectAll()">
        </app-admin-tools-table>
    </ng-container>
</app-material>
<app-tool-create-modal
    [tool]="selectedTool"
    (createTool)="onCreateTool($event)"
    (onUpdate)="onUpdateTool($event)"
    (onDelete)="onDeleteTool($event)"
    (onClose)="onModalClose($event)">
</app-tool-create-modal>

<app-tool-bulk-update-modal
    *ngIf="selectableTools && selectedToolCount > 0"
    [isLoading]="isLoadingBulkUpdate"
    (onUpdate)="onBulkUpdate($event)">
</app-tool-bulk-update-modal>

<app-tool-bulk-reset-modal
  *ngIf="selectableTools && selectedToolCount > 0"
  [isLoading]="isLoadingBulkReset"
  (onBulkReset)="onBulkReset($event)"
  (onClose)="onModalClose($event)">
</app-tool-bulk-reset-modal>

<app-tool-document-generation-modal
  *ngIf="selectableTools && selectedToolCount > 0"
  [isLoading]="isLoadingDocumentGeneration"
  (generateDocuments)="onGenerateDocuments($event)">
</app-tool-document-generation-modal>

<app-add-tool-in-set-modal
    [tool]="selectedTool">
</app-add-tool-in-set-modal>

<app-confirm-delete-modal
    [scannedTools]="scannedTools"
    [isToolSet]="true"
    (confirmDelete)="onConfirmDeleteToolSet($event)"
>
</app-confirm-delete-modal>
